module.exports = __webpack_public_path__ + "static/media/29ADMSPC13.ca19a17e.jpg";